import styled from 'styled-components';
export const PremiumFeatureOverlayWrapper = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
export const PremiumFeatureOverlayContainer = styled.div `
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60%;
  pointer-events: none;
  z-index: 50;

  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    mask-image: linear-gradient(to top, black 60%, transparent 100%);

    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 0.6) 60%,
      rgba(255, 255, 255, 0) 80%
    );
    backdrop-filter: blur(20px);
  }
`;
export const PremiumFeatureOverlayContent = styled.div `
  position: relative;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey_2};
  background: ${({ theme }) => theme.colors.white_1};
  box-shadow: 0px 6px 11px rgba(0, 0, 0, 0.12);
  max-width: min(85%, 1000px);
  max-height: 85%;
  width: 100%;
  margin: 0 auto;
  height: fit-content;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  box-sizing: border-box;
`;
export const PremiumOverlayCardContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const PremiumOverlayCardContent = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
export const PremiumOverlayCardActions = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;
